import axios from 'services/axios';
import { Product, UnresolvedResourcesOptions } from '../types';

import { getProductsQuery } from './queries/getProductsQuery';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

export type GetProductsResponse = {
  data: { products: Product[] };
  next_token: string;
  error_type: string;
};

export const getProducts = async ({
  org_id,
  since,
  before,
  limit,
  needs_resolving,
  operation_type,
  next_token,
}: UnresolvedResourcesOptions): Promise<GetProductsResponse> => {
  try {
    const response: { data: GetProductsResponse } = await axios.post(
      `${VITE_APP_API_URL}/opensearch/v3/graphql/`,
      {
        query: getProductsQuery,
        variables: { org_id, since, before, limit, needs_resolving, operation_type, next_token },
      },
    );
    return response.data;
  } catch (err: any) {
    return err;
  }
};
